module.exports = __webpack_public_path__ + "images/category_lp/camera/camera_0c4f50a5e3af44a4978aa7b41b3dda4a.png";